import { Box, Avatar, Typography } from '@mui/material';

/**
 * Cabecera de branding del cliente en el portal de postulación / subida de
 * documentos. Muestra (si está configurado en el branding del proyecto): un
 * banner ancho arriba y una barra con logo y/o nombre. NUNCA muestra branding
 * de la plataforma: si no hay banner ni logo ni nombre, no renderiza nada.
 */
const PortalBrandingHeader = ({ branding }) => {
  if (!branding) return null;

  const { logoUrl, companyName, bannerUrl } = branding;
  const logo = logoUrl || null;
  const name = companyName || null;
  const banner = bannerUrl || null;

  if (!logo && !name && !banner) return null;

  return (
    <>
      {banner && (
        <Box
          component="img"
          src={banner}
          alt=""
          sx={{ width: '100%', maxHeight: 240, objectFit: 'cover', display: 'block' }}
        />
      )}
      {(logo || name) && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1.5,
            py: 2,
            px: 2,
            backgroundColor: '#fff',
            borderBottom: '1px solid #E5E7EB',
          }}
        >
          {logo && (
            <Avatar
              src={logo}
              variant="rounded"
              sx={{ width: 44, height: 44, bgcolor: 'transparent' }}
            />
          )}
          {name && (
            <Typography variant="h6" fontWeight={700} sx={{ color: '#111827' }}>
              {name}
            </Typography>
          )}
        </Box>
      )}
    </>
  );
};

export default PortalBrandingHeader;
